"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getAsSet = exports.someScoped = exports.isScoped = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var _Raven = _interopRequireDefault(require("Raven"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _BaseContainer = _interopRequireDefault(require("./BaseContainer"));

var _immutable = require("immutable");

var _identity = _interopRequireDefault(require("transmute/identity"));

var ScopesContainer = _BaseContainer.default.create();

var _userIsScoped = function _userIsScoped(scopes, scopeToCheck) {
  var value = scopes[scopeToCheck];
  var isNotDev = !_enviro.default.isProd() && !_enviro.default.deployed() && !window.jasmine;

  if (value === undefined && isNotDev) {
    var message = '[CRM ScopesContainer] Undefined scope value. Was this scope declared in crm_internal/setup/SettingsSetup?';

    _Raven.default.captureMessage(message, {
      extra: {
        gate: scopeToCheck
      }
    }); // eslint-disable-next-line no-console


    console.error(message, scopeToCheck);
  }

  return value === true;
};

var _isScoped = function isScoped(scopesToCheck) {
  var scopes = ScopesContainer.getContainer().get();
  return Array.isArray(scopesToCheck) ? scopesToCheck.every(function (scopeToCheck) {
    return _userIsScoped(scopes, scopeToCheck);
  }) : _userIsScoped(scopes, scopesToCheck);
};

exports.isScoped = _isScoped;

var _someScoped = function someScoped(scopesToCheck) {
  (0, _invariant.default)(Array.isArray(scopesToCheck), 'ScopesContainer: expected scopes to be Array but got "%s"');
  var scopes = ScopesContainer.getContainer().get();
  return scopesToCheck.some(function (scopeToCheck) {
    return _userIsScoped(scopes, scopeToCheck);
  });
};

exports.someScoped = _someScoped;

var _getAsSet = function getAsSet() {
  return (0, _immutable.fromJS)(ScopesContainer.getContainer().get()).filter(_identity.default).keySeq().toSet();
};

exports.getAsSet = _getAsSet;

var _default = Object.assign(ScopesContainer, {
  get: function get() {
    throw new Error('ScopesContainer.get() is no longer supported. Use ScopesContainer.getContainer().get() instead.');
  },
  isScoped: function isScoped(scopesToCheck) {
    return _isScoped(scopesToCheck);
  },
  someScoped: function someScoped(scopesToCheck) {
    return _someScoped(scopesToCheck);
  },
  getAsSet: function getAsSet() {
    return _getAsSet();
  }
});

exports.default = _default;